export default "__VITE_ASSET__DR76dN3V__"